// extracted by mini-css-extract-plugin
module.exports = {"input":"MultiSelectField_input__2C-tc","dropdown":"MultiSelectField_dropdown__DcSsb","dropdownItem":"MultiSelectField_dropdownItem__1HSOS"};